import { TablePagination, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  allLaboratory,
  editLaboratory,
} from "../../actions/laboratory-actions";
import { getActiveRegionals } from "../../actions/regional-actions";
import SearchLaboratory from "../../componentes/laboratory/searchLaboratory";
import TableLaboratory from "../../componentes/laboratory/tableLaboratory";
import { useStateValue } from "../../context/store";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import Search from "../../images/icons/search.svg";
import { styles } from "../styles";
import moment from "moment";
import SearchExams from "../../componentes/medicalExam/searchExams";

const Exams = (props) => {
  return (
    <div>
      <SearchExams />
    </div>
  );
};

export default Exams;
